import { createContext, useContext } from "react";

import { type FocusTrap, type Options, createFocusTrap as createFocusTrapOriginal } from "focus-trap";

export type { FocusTrap } from "focus-trap";

export const createFocusTrap = (
  element: HTMLElement | SVGElement | string | Array<HTMLElement | SVGElement | string>,
  userOptions?: Options,
): FocusTrap => {
  return createFocusTrapOriginal(element, userOptions);
};

const FocusTrapContext = createContext<FocusTrap | null>(null);

export const FocusTrapContextProvider = FocusTrapContext.Provider;

export const useFocusTrapContext = () => useContext(FocusTrapContext);
